const vmList = {};
export default vmList;



// WEBPACK FOOTER //
// ./src/utils/popup-fun/vm-list.js